/**
 * Automatically wraps buttons with 3D effect structure
 * Handles buttons that aren't rendered through Liquid snippets
 */

(function() {
  'use strict';

  /**
   * Wraps a button element with 3D structure
   * @param {HTMLElement} button - The button element to wrap
   */
  function wrapButtonWith3D(button) {
    // Skip if already wrapped, is unstyled, or is skip link
    if (button.closest('.button-3d-wrapper') || 
        button.classList.contains('button-unstyled') ||
        button.classList.contains('skip-to-content-link')) {
      return;
    }

    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'button-3d-wrapper';
    
    // Add class based on button type for border-radius
    if (button.classList.contains('button-secondary')) {
      wrapper.classList.add('button-3d-wrapper--secondary');
    } else {
      wrapper.classList.add('button-3d-wrapper--primary');
    }

    // Create shadow layer
    const shadow = document.createElement('span');
    shadow.className = 'button-3d-shadow';

    // Create edge layer
    const edge = document.createElement('span');
    edge.className = 'button-3d-edge';

    // Create front layer
    let front = document.createElement('span');
    front.className = 'button-3d-front';
    
    // Copy all classes from button to front layer (except button-3d-wrapper related)
    const buttonClasses = Array.from(button.classList);
    buttonClasses.forEach(cls => {
      if (!cls.startsWith('button-3d-')) {
        front.classList.add(cls);
      }
    });

    // Move button content to front layer
    while (button.firstChild) {
      front.appendChild(button.firstChild);
    }

    // Copy attributes from button to front (except class)
    Array.from(button.attributes).forEach(attr => {
      if (attr.name !== 'class' && !attr.name.startsWith('data-button-3d-')) {
        front.setAttribute(attr.name, attr.value);
      }
    });

    // If button is an <a> tag, convert front to <a> as well
    if (button.tagName === 'A') {
      const link = document.createElement('a');
      Array.from(front.attributes).forEach(attr => {
        link.setAttribute(attr.name, attr.value);
      });
      link.className = front.className;
      while (front.firstChild) {
        link.appendChild(front.firstChild);
      }
      front.replaceWith(link);
      front = link;
    }

    // Assemble structure
    wrapper.appendChild(shadow);
    wrapper.appendChild(edge);
    wrapper.appendChild(front);

    // Replace button with wrapper
    button.parentNode.replaceChild(wrapper, button);
  }

  /**
   * Process all buttons on the page
   */
  function processButtons() {
    // Find all buttons and links with button classes
    const buttons = document.querySelectorAll(
      'button.button:not(.button-unstyled):not(.skip-to-content-link), ' +
      'a.button:not(.button-unstyled):not(.skip-to-content-link), ' +
      'button.button-secondary:not(.button-unstyled):not(.skip-to-content-link), ' +
      'a.button-secondary:not(.button-unstyled):not(.skip-to-content-link), ' +
      'button.shopify-payment-button__button--unbranded'
    );

    buttons.forEach(button => {
      wrapButtonWith3D(button);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processButtons);
  } else {
    processButtons();
  }

  // Also run after a short delay to catch dynamically added buttons
  setTimeout(processButtons, 100);
  setTimeout(processButtons, 500);

  // Watch for dynamically added buttons using MutationObserver
  const observer = new MutationObserver(function(mutations) {
    let shouldProcess = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.classList && (
            node.classList.contains('button') ||
            node.classList.contains('button-secondary') ||
            node.classList.contains('shopify-payment-button__button--unbranded')
          ) && !node.classList.contains('button-unstyled')) {
            shouldProcess = true;
          }
          // Check children
          if (node.querySelectorAll) {
            const buttons = node.querySelectorAll(
              'button.button:not(.button-unstyled):not(.skip-to-content-link), ' +
              'a.button:not(.button-unstyled):not(.skip-to-content-link), ' +
              'button.button-secondary:not(.button-unstyled):not(.skip-to-content-link), ' +
              'a.button-secondary:not(.button-unstyled):not(.skip-to-content-link), ' +
              'button.shopify-payment-button__button--unbranded'
            );
            if (buttons.length > 0) {
              shouldProcess = true;
            }
          }
        }
      });
    });
    if (shouldProcess) {
      setTimeout(processButtons, 50);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

